import React, { useState, useEffect } from "react";
import { Globe, Menu, X } from "lucide-react";
import "./header.css";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`header ${isScrolled ? "scrolled" : ""}`}>
      <div className="container header-container">
        <div className="logo">
          <img
            src="/images/logo.png"
            alt="Lothal International Logo"
            className="logo-icon"
            width="75"
            height="75"
          />
        </div>

        <nav className={`nav-menu ${mobileMenuOpen ? "active" : ""}`}>
          <a href="#home" className="nav-link">
            Home
          </a>
          <a href="#about" className="nav-link">
            About Us
          </a>
          <a href="#services" className="nav-link">
            Services
          </a>
          <a href="#industries" className="nav-link">
            Industries
          </a>
          <a href="#tracking" className="nav-link">
            Tracking
          </a>
          <a href="#contact" className="nav-link">
            Contact Us
          </a>
        </nav>

        <div className="header-cta">
          <button className="btn btn-outline">Track Shipment</button>
          <button className="btn btn-primary">Get Quote</button>
        </div>

        <button
          className="mobile-menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <X /> : <Menu />}
        </button>
      </div>
    </header>
  );
};

export default Header;
